import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import { useCustomFieldConfigMutations } from "hooks/useCustomFieldConfigTable";
import DeleteFieldModal from "routes/custom_field/components/DeleteFieldModal";

const EDIT_ACLS = [ACL_RELATIONSHIPS.customFieldConfig.edit];
const DELETE_ACLS = [ACL_RELATIONSHIPS.customFieldConfig.delete];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS];

export function CustomFieldConfigTableActions({ original }) {
  const navigate = useNavigate();
  const [deleteOpen, setDeleteOpen] = useState(false);

  const { remove } = useCustomFieldConfigMutations({
    onDeleted: () => setDeleteOpen(false),
  });

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Custom field config actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="tw:w-auto">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem
                onClick={() =>
                  navigate(`/settings/custom_field_configs/${original.id}`)
                }
              >
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Delete
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <Authorized permissions={DELETE_ACLS}>
          <DeleteFieldModal
            open={deleteOpen}
            onOpenChange={setDeleteOpen}
            label={original.label}
            modelType={original.model_type}
            onConfirm={() => remove.mutate(original.id)}
          />
        </Authorized>
      </>
    </Authorized>
  );
}
